export const esLang = {
  translation: {
    data: 'Datos',
    date: 'Fecha',
    view_all: 'Ver todos',
    add: 'Añadir',
    edit: 'Editar',
    update: 'Actualizar',
    share: 'Compartir',
    details: 'Detalles',
    list: 'Lista',
    tags: 'Etiquetas',
    type: 'Tipo',
    name: 'Nombre',
    groups: 'Grupos',
    search: 'Buscar',
    start_date: 'Desde',
    end_date: 'Hasta',
    workspace: 'Espacio de trabajo',
    last_measure: 'Última medida',
    state: 'Estado',
    any_state: 'Cualquier estado',
    state_active: 'Activo',
    state_inactive: 'Inactivo',
    state_to_be_deleted: 'Para ser borrado',
    dashboard: 'Panel de control',
    home: 'Inicio',
    trackgas: 'TrackGas',
    notifications: 'Notificaciones',
    notifications_pending_read: 'Tiene {{notifications_count}} notificaciones son leer',
    notifications_view_all: 'Ver todas las notificaciones',
    device_changes: 'Cambios en dispositivos',
    reports: 'Informes',
    mgb_alarm_desc: 'El nivel de {{metric}} baja de {{level}}',
    mga_alarm_desc: 'El nivel de {{metric}} sube de {{level}}',
    mgbt_alarm_desc: 'El nivel de {{metric}} está entre {{bottom_level}} y {{top_level}}',
    device_add: 'Añadir un dispositivo',
    device_shared_successfuly: 'Dispositivo compartido correctamente',
    device_edit_successfuly: 'Dispositivo editado correctamente',
    devices: 'Dispositivos',
    device_details_breadcrumb: 'Detalles de {{device_name}}',
    identifier: 'Identificador',
    devices_export: 'Exportar dispositivos',
    device_groups: 'Grupo de dispositivos',
    device_groups_placeholder: 'Seleccione de la lista',
    device_location: 'Ubicación del dispositivo',
    device_properties: 'Propiedades del dispositivo',
    device_alarm_state: 'El dispositivo está en estado de alarma',
    device_back_to_normal_state: 'El dispositivo ha vuelto a la normalidad',
    select_device_type: 'Seleccione el tipo de dispositivo',
    calculated_data: 'Datos calculados',
    assets: 'Activos',
    configuration: 'Configuración',
    alarms: 'Alarmas',
    add_alarm: 'Añadir una alarma',
    edit_alarm: 'Editar alarma',
    alarm_created: 'Alarma creada',
    alarm_updated: 'Alarma actualizada',
    alarm_select_time_window: 'Seleccione el tipo de ventana temporal',
    alarm_select_time_window_time_window: 'Ventana temporal',
    alarm_select_time_window_measure_count: 'Recuento de medidas',
    alarm_select_time_window_measure_count_explanation:
      'Se tomará el número de medidas especificado y se utilizará el valor medio de las mismas para evaluar el disparador.',
    alarm_select_time_window_time_window_explanation:
      'Se tomará todas las que se hayan recibido en el intervalo especificado.',
    alarm_select_time_window_time_window_select_units: 'Seleccione las unidades',
    hours: 'Horas',
    days: 'Días',
    alarm_select_trigger: 'Seleccione el tipo de disparador',
    alarm_new_data_trigger: 'Evaluar con cada dato nuevo',
    alarm_scheduled_trigger: 'Evaluar de manera programada',
    alarm_time_window_header: 'Ventana de tiempo',
    alarm_time_window_content:
      'La ventana de tiempo define las condiciones temporales de la alarma. Existen dos tipos de ventana. La ventana basada en número de medidas y una ventana basada en unidades temporales (minutos, horas, días...)',
    alarm_trigger_header: 'Disparador',
    alarm_trigger_content:
      'La configuración del disparador define cuando se ha de activar o desactivar la alerta. Existen dos tipos de disparador. Por <bold>nivel de medida</bold>, que se dispara cuando el valor de una medida cumple una serie de condiciones (estar por encima o por debajo de un nivel definido, o estar entre dos niveles definidos). Disparador <bold>por ausencia de medidas</bold>. Este disparador se activa cuando no se reciben medidas según el plazo estipulado en la ventana de tiempo. En este caso se ha de usar una ventana del tipo temporal.',
    actions_header: 'Acciones',
    actions_content:
      'Lista de acciones a realizar cuando una alarma se dispare o vuelva a la normalidad. Cada accion se puede configurar para que se active solo cuando la alarma entra en estado de alarma, solo cuando vuelve a la normalidad o en ambos casos.',
    alarm_action_notify_alarm_state: 'Notificar los estados de alarma',
    alarm_action_notify_back_to_normal_state: 'Notificar la vuelta a la normalidad',
    shared: 'Compartido',
    select_language: 'Seleccione idioma',
    en: 'English',
    es: 'Castellano',
    autodetect: 'Detectar',
    error_unable_to_logout: 'No se ha podido cerrar la sesión',
    alarm_state_change_list: 'Histórico de cambios de estado',
    alarm_state_change_desc: '{{alarm_name}} pasa a estado {{alarm_state}}',
    received_data: 'Datos recibidos',
    measure_updated: 'Medida actualizada',
    measure_updated_error: 'Error al actualizar la medida',
    update_measure_text: 'Los valores originales serán sobreescritos',
    device_delete_cta: 'Borrar este dispositivo',
    device_delete_confirm: '¿Confirma el borrado de este dispositivo?',
    device_delete_confirm_dialog: 'Esta acción no se puede deshacer.',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    'receive.weekly_reports': 'Recibir informe de estado semanal',
    'receive.monthly_reports': 'Recibir informe de estado mensual',
    'receive.daily_reports': 'Recibir informe de estado diario',
    delivery_configuration: 'Transporte',
    download_report: 'Descargar informe',
    deposit_state: 'Estado del depósito',
    gasoil_type: 'Tipo de gasóleo',
    liters_available: 'Volumen libre',
    consum_charts: 'Gráficas de consumo',
    measure_chart: 'Gráficas de medición',
    deposit_details: 'Detalles del depósito',
    data_included: 'Información incluida',
    charts: 'Gráficas',
    format: 'Formato',
    share_report: 'Compartir informe',
    send: 'Enviar',
    download: 'Descargar',
    trimester: 'Trimestre',
    to_now: 'Hasta hoy',
    trimestral: 'Trimestral',
    annual: 'Anual',
    temporal_interval: 'Intervalo temporal',
    add_deposit: 'Añadir depósito',
    deposits: 'Depósitos',
    deposits_selected: 'depósitos seleccionados',
    auto_reports: 'Informes automáticos',
    request_delivery: 'Solicitar Suministro',
    last_temperature: 'Última temperatura',
    capacity: 'Capacidad',
    raw_value: 'Valor RAW',
    unknown: 'Desconocido',
    fill: 'Llenado',
    last_fill: 'Último llenado',
    provider: 'Proveedor',
    measurement: 'Medición',
    last_measurement: 'Última medición',
    recurrence: 'Recurrencia',
    maintenance: 'Mantenimiento',
    last_revision: 'Última revisión',
    next_revision: 'Próxima revisión',
    contact: 'Contacto',
    do_you_have_doubts: '¿Tienes dudas?',
    contact_with_distributor: 'Contacta con tu distribuidor',
    contact_name: 'Nombre del contacto',
    consum_chart: 'Gráfica de consumo',
    weekly: 'Semanal',
    monthly: 'Mensual',
    receive_alert_when: 'Recibir alerta cuando la capacidad del depósito sea',
    less_than_15: 'inferior al 15%',
    deposit_capacity: 'Capacidad del depósito',
    daily_average_consum: 'Consumo medio diario',
    weekly_average_consum: 'Consumo medio semanal',
    remaining_days: 'Días restantes',
    new_request: 'Nuevo pedido',
    deposit_empty_in: 'Depósito vacío en',
    request_gasoil: 'Pedir Gasoleo',
    you_can_downloa_report:
      'Puede descargar el informe de estado en cualquier momento seleccionado una fecha y pulsando el botón',
    deposit: 'Depósito',
    place: 'Lugar',
    recurrence_measurement: 'Recurrencia medición',
    fill_state: 'Estado llenado',
    fill_prevision: 'Previsión llenado',
    new_delivery: 'Nuevo Suministro',
    TOTAL: 'TOTAL',
    la_solicitud_del_suministro:
      'La solicitud de Suministro estará disponible próximamente. Disculpa las molestias.',
    received_date: 'Fecha de recepción',
    delivery_configurations: 'Configuraciones de envío',
    add_delivery_configuration: 'Añadir una configuración de envío',
    delivery_configuration_created: 'Configuración de envío creada',
    create_delivery_configuration: 'Crear configuración de envío',
    bulk: 'Graneles',
    fixed: 'Fijado',
    unit: 'Unidad',
    slots: 'Celdas',
    slot_amount: 'Cantidad por celda',
    min_slots: 'Celdas mínimo',
    max_slots: 'Celdas máximo',
    min: 'Mínimo',
    max: 'Máximo',
    device_type: 'Tipo de dispositivo',
    name_is_required: 'El nombre es necesario',
    welcome_again: 'Hola, bienvenido de vuelta a',
    access_to_giraf: 'Accede a Giraf.io',
    enter_credentials: 'Introduce tus credenciales debajo',
    tag_device_created: 'Etiqueta de dispositivo creada',
    tag_device_updated: 'Etiqueta de dispositivo actualizada',
    add_tag: 'Añadir una etiqueta',
    changes_alarm_state: 'Cambios de estado de las alarmas',
    download_reports: 'Descarga de informes',
    change_in_alarm_state: 'Cambio en el estado de la alarma',
    created: 'Creado',
    alert_state: 'Estado Alerta',
    device_identifier: 'Identificador de dispositivo',
    device_name: 'Nombre del dispositivo',
    last_data_received: 'Último dato recibido',
    last_data: 'Fecha último dato',
    alarm_data: 'Información de la alarma',
    without_alarm_asociated: 'sin alarma asociada',
    delivery_configuration_updated: 'Configuración de envío actualizada',
    aprox_weight: 'Peso aprox.',
    daily_consum: 'Consumo diario',
    weekly_consum: 'Consumo semanal',
    edit_delivery_configuration: 'Editar configuración de envío',
    solicitud_de_suministro: 'Solicitud de suministro enviada correctamente',
    emails_list: 'Lista de emails',
    add_email: 'Añadir email',
    feed_type: 'Tipo de pienso',
    breeding_number: 'Número de crianza',
    select_feed_type: 'Seleccione el tipo de pienso',
    save: 'Guardar',
    delivery_requests: 'Solicitudes de suministro',
    user: 'Usuario',
    status: 'Estado',
    silos: 'Silos',
    total_load: 'Carga total',
    delivery_date: 'Fecha de envío',
    see_detail: 'Ver detalle',
    detail: 'Detalle',
    product_types: 'Tipos de piensos',
    options: 'Opciones',
    add_product_type: 'Añadir Tipo de pienso',
    product_type_created: 'Tipo de pienso creado',
    create_product_type: 'Crear tipo de pienso',
    product_type: 'Tipo de producto',
    confirm_delete_product_type: '¿Estás seguro que quieres eliminar el tipo de pienso?',
    product_type_deleted: 'Tipo de pienso eliminado',
    delete_product_type: 'Eliminar Tipo de pienso',
    product_schedule: 'Crianza',
    product_schedule_template_created: 'Plantilla creada',
    product_schedule_created: 'Crianza creada',
    product_schedule_template_edited: 'Plantilla editada',
    create_product_template_schedule: 'Crear plantilla',
    product_schedule_edited: 'Crianza editada',
    create_product_schedule: 'Crear crianza',
    edit_product_schedule: 'Editar crianza',
    by_unit: 'Por unidad',
    schedule_type: 'Tipo de programación',
    quantity: 'Cantidad',
    select_product_type: 'Selecciona el tipo de pienso',
    ordinal: 'Orden',
    type_is_required: 'El tipo es requerido',
    requited_one_product_type: 'El necesario introducir por lo menos un tipo de pienso',
    product_schedule_templates: 'Plantillas de programación de crianza',
    add_product_schedule_template: 'Añadir plantilla de crianza',
    confirm_delete_product_schedule_template:
      '¿Seguro que quieres eliminar esta plantilla de programación de crianza?',
    delete_product_schedule_template: 'Eliminar pantilla de crianza',
    product_schedule_template_deleted: 'Plantilla de programación de crianza eliminado',
    n_items: '# items',
    schedules: 'Crianzas',
    schedule_templates: 'Plantillas de crianza',
    add_product_schedule: 'Añadir crianza',
    template: 'Plantilla',
    units: 'Unidades',
    reference: 'Referencia',
    units_is_required: 'Unidades es obligatorio',
    template_is_required: 'La plantilla es obligatoria',
    devices_is_required: 'Debes indicar por lo menos un dispositivo',
    reference_is_required: 'La referencia es obligatoria',
    devices_at_least_1: 'Debes indicar por lo menos un dispositivo',
    consumed: 'Consumido',
    product_schedules: 'Crianzas',
    n_devices: '# dispositivos',
    n_kilos_consumed: '# kilos consumidos',
    required: 'Campo obligatorio',
    active: 'Activo',
    inactive: 'Inactivo',
    phases: 'Fases de la ',
    breeding: 'crianza',
    Breeding: 'Crianza',
    breeding_details: 'Detalles de la crianza',
    breeding_devices: 'Dispositivos de la crianza',
    device_details: 'Detalles del dispositivo',
    products_list: 'Lista de productos',
    order_summary: 'Resumen del pedido',
    device_not_asigned_breeding: 'Este dispositivo no está asignado a ninguna crianza',
    add_building: 'Añadir nave',
    assign_building: 'Asignar nave',
    create_building: 'Crear nave',
    building_created: 'Nave creada',
    building_updated: 'Nave actualizada',
    edit_building: 'Editar nave',
    device_assigned_to_building: 'Dispositivo asignado a una nave',
    add_device_to_this_building: 'Añadir un dispositivo a esta nave',
    building_assigned_to_devicetag: 'Nave asignada a granja correctamente',
    building_unlink_success: 'Nave desvinculada correctamente',
    unlink_building: 'Desvincular nave',
    assign_building_to: 'Asignar nave a ',
    device_unlinked_to_building: 'Dispositivo desvinculado de la nave',
    confirm_unlink_device: '¿Estás seguro que quieres desvincular este dispositivo de esta nave?',
    building: 'Nave',
    device_group: 'Grupo de dispositivo',
    device_group_created: 'Grupo de dispositivo creado',
    device_group_updated: 'Grupo de dispositivo actualizado',
    assign_device: 'Asignar un dispositivo',
    device: 'Dispositivo',
    assign_device_to: 'Asignar dispositivo a',
    create_device: 'Crear dispositivo',
    device_added: 'Dispositivo creado correctamente',
    download_failed: 'Descarga fallida',
    never: 'Nunca',
    available: 'disponibles',
    device_information: 'Información del depósito',
    free_space: 'Volumen libre',
    available_charge: 'Volumen aproximado',
    deposit_type: 'Tipo de deposito',
    sector: 'Sector',
    welcome_to: 'Bienvenido a',
    link_incorrect_or_timed_out: 'Este enlace es incorrecto, o ha caducado',
    to_access_panel_set_password: 'Para acceder al panel, establece una contraseña',
    set_password: 'Establecer contraseña',
    return: 'Volver',
    confirm_order: 'Confirmación de pedido',
    insert_comment: 'Introduce un comentario',
    comment: 'Comentario',
    confirm_the_reception_of_delivery_request:
      'Confirma la recepción de la solicitud de suministro',
    confirm_reception: 'Confirmar recepción',
    go_to_login: 'Ir al login',
    unlink: 'Desvincular',
    confirm_unlink_building: '¿Estás seguro que quieres desvincular este dispositivo?',
    unlink_device: 'Desvincular dispositivo',
    product_list: 'Lista de productos',
    delivery_request_received_confirmed: 'Confirmación de recepción de Solicitud de suministro',
    of: 'de',
    confirmed: 'Confirmado',
    delivered: 'Enviado',
    general_data: 'Datos generales',
    add_devices: 'Añadir dispositivos',
    select_devices: 'Seleccionar dispositivos',
    percent: 'Porcentaje',
    remain: 'Volumen aproximado',
    temperature: 'Temperature',
    battery_level: 'Nivel de batería',
    consumption_graphs: 'Gráficas de consumo',
    measurement_charts: 'Gráficas de medición',
    report_sended_correctly: 'Informe enviado correctamente',
    each_8_hours: 'Cada 8 horas',
    each_4_hours: 'Cada 4 horas',
    each_12_hours: 'Cada 12 horas',
    silos_and_gasoil_deposit: 'Silos y depósitos de gas',
    counters: 'Contadores',
    to_change_date_use_selector: 'Si desea cambiar la fecha puede usar el selector.',
    under_construction: 'En construcción',
    we_are_working: 'Estamos trabajando para tener disponible esta página lo antes posible.',
    sensor_calibration_text:
      'Los sensores deben ser calibrados para poder mostrar la información correctamente. Cuando haya sido calibrado este sensor, marcar la casilla.',
    pending_calibration: 'Calibración pendiente',
    statistics: 'Estadísticas',
    supply_requests: 'Solicitudes de suminsitro',
    alarm_notifications: 'Avisos de alarmas',
    consumption: 'Consumo',
    then_last_year: 'Que el año pasado',
    invite: 'Invitar',
    no_breeding: 'Sin crianza',
    pending_deliveries: 'Envíos pendientes',
    pending_delivery_requests:
      'Este dispositivo tiene solicitudes de suministro pendientes de recibir.',
    created_date: 'Fecha de creación',
    delivery_request: 'Solicitud de suministro',
    items: 'Items',
    total: 'Total',
    delivery_request_deleted: 'Solicitud de suministro eliminada',
    delivery_request_confirm: 'Confirma la eliminación',
    delivery_request_delete_confirm_dialog:
      '¿Estás seguro que quieres eliminar esta solicitud de suministro?',
    message: 'Mensaje',
    volumen_aproximado: 'Volumen aproximado',
    do_not_you_remember_your_password: '¿No recuerdas tu contraseña?',
    please_fill_your_email:
      'Por favor introduce el email asociado a tu cuenta y te enviaremos un código de confirmación para resetear tu contraseña.',
    request_sent_correctly: 'Solicitud enviada correctamente',
    we_have_sent_an_email_to: 'Hemos enviado un código a',
    please_check_you_maibox:
      'Por favor comprueba tu email, y copia y pega el código debajo para poder resetear tu contraseña',
    reset_password: 'Configura tu contraseña',
    email_incorrect: 'Email incorrecto',
    email_required: 'Email obligatorio',
    email_address: 'Dirección de correo electrónico',
    restart_password: 'Restablecer contraseña',
    input_error:
      'Los campos Tipo de depósito, Identificador, Nombre, Estado y Dirección son obligatorios.',
    stock_history: 'Histórico de stocks',
    device_shared: 'Dispositivos compartidos',
    device_shared_delete: 'Confirma eliminación de dispositivo compartido',
    device_shared_delete_dialog: '¿Estás seguro que quieres eliminar este dispositivo compartido?',
    device_shared_deleted: 'Dispositivo compartido eliminado',
    shared_with: 'Compartido con',
    device_tag_shared: 'Grupo de dispositivos compartido',
    device_and_tags_shared: 'Dispositivos y grupos de dispositivos compartidos',
    device_tags_shared: 'Grupos de dispositivos compartidos',
    error_getting_devices: 'Error al obtener los dispositivos',
    tag_shared_delete_dialog: '¿Estás seguro que quieres eliminar el grupo de dispositivos?',
    tag_shared_delete: 'Eliminar grupo de dispositivo compartido',
    province: 'Provincia',
    password_set_correctly: 'Contraseña asignada correctamente',
    register_in_giraf: 'Registrate en Giraf',
    minimum_3_chars: 'Mínimo 3 carácteres',
    maximum_255_chars: 'Máximo 255 carácteres',
    maximum_150_chars: 'Máximo 150 carácteres',
    valid_email: 'El email debe ser correcto',
    register_success: 'Registro correcto',
    register: 'Registrarse',
    url: 'URL',
    email: 'Email',
    creating_workspace: 'Creando espacio de trabajo',
    creating_user: 'Creando usuario',
    register_success_reset_password_sent:
      'Hemos dado de alta correctamente el espacio de trabajo. Por favor, establece tu contraseña desde el link que te hemos enviado al correo electrónico',
    password: 'Contraseña',
    password_rules:
      'La contraseña debe tener al menos una letra mayúscula, un número y un caracter especial',
    email_is_required: 'El email es obligatorio',
    'name.not_empty_string': 'Nombre obligatorio',
    'identifier.not_empty_string': 'Identificador requerido',
    'location.not_empty_string': 'Ubicación requerido',
    'deviceTypePreset.not_empty_string': 'Tipo de dispositivo (deviceTypePreset) requerido',
    'deviceType.not_empty_string': 'Tipo de dispositivo (deviceType) requerido',
    'state.not_empty_string': 'Estado requerido',
    parameters: 'Parametros',
    'parameters.not_empty_string': 'Parámetros requerido',
    volume: 'Volumen',
    level: 'Nivel',
    picture: 'Imagen',
    value: 'Valor',
    battery: 'Batería',
    ocr_counter_state: 'Estado del contador OCR',
    update_profile: 'Actualizar perfil',
    update_profile_text: 'Puedes actualizar tu perfil aquí',
    update_profile_success: 'Perfil actualizado correctamente',
    update_profile_load: 'Actualizando perfil',
    deposit_l: 'Depósito (L)',
    calibration_text_1: 'Para calibrar el dispositivo, pulsa en un punto de la gráfica',
    click_on: 'Pulsa un ',
    second_point: 'segundo punto',
    to_complete_calibration: 'para completar la calibración',
    device_calibration: 'Calibración del dispositivo',
    device_calibration_text_1:
      'A continuación puedes ver los dos puntos de calibración. Debajo de cada punto está la fecha de la medida y todos los datos disponibles para este punto.',
    device_calibration_text_2:
      'Para calibrar, asigna un valor en Kg en "Valor Punto 1", y en "Valor Punto 2".',
    device_calibration_text_3:
      'Todavía no se puede guardar las medidas. Próximamente completaremos el desarrollo de esta sección.',
    point_value_1: 'Valor Punto 1',
    point_value_2: 'Valor Punto 2',
    calibration_sended: 'Calibración enviada',
    almost_one_point_different_0: 'Uno de los puntos debe ser distinto de 0',
    send_calibration: 'Enviar calibración',
    kilos: 'Kilos',
    download_pdf: 'Descargar PDF',
    device_deport_of: 'Informe del dispositivo',
    chart_measurements: 'Gráfica de medidas',
    from: 'desde',
    to: 'hasta',
    define_sector: 'Debes definir un sector',
    define_client_number: 'Debes definir un número de cliente',
    naves: 'Naves',
    select_a_value: 'Seleccione un valor',
    error_downloading_try_parts:
      'Ha habido un error descargando el informe. Vamos a intentarlo por partes',
    code: 'Código',
    repeat_password: 'Repite contraseña',
    change_password: 'Cambiar contraseña',
    code_required: 'Código requerido',
    password_required: 'Contraseña requerida',
    passwords_must_match: 'Las contraseñas deben coincidir',
    password_changed_successfully: 'Contraseña cambiada correctamente',
    login: 'Iniciar sesión',
    remember_me: 'Recuérdame',
    new_password: 'Nueva contraseña',
    confirm_new_password: 'Confirmar nueva contraseña',
    login_success: 'Inicio de sesión correcto',
    email_must_have_correct_email:
      'El campo email debe contener una dirección de correo electrónico correcta.',
    email_valid_address: 'El email debe ser una dirección válida',
    new_password_required: 'La nueva contraseña es obligatoria',
    confirm_new_password_is_required: 'La confirmación de la nueva contraseña es obligatoria',
    cumulative_flow: 'Flujo acumulado',
    maximum_capacity: 'Capacidad máxima',
    actual_weight: 'Peso actual',
    free_weight: 'Peso libre',
    consumed_kilos: 'Kilos consumidos'
  }
};
